<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    :validations="validations.unidade"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        unidades() {

            return this.data.form.unidades.filter(u => u.infraestruturas.length >
                this.data.model.prestadoresInternos.filter(p => p.unidadeId === u.id).length)
        },
        infraestruturas() {

            if (!this.model.unidadeId) {

                return []
            }

            return this.data.form.unidades
                .find(u => u.id === this.model.unidadeId)
                .infraestruturas
                .filter(i => !this.infraestruturasPrestadorasIds.includes(i.id))
        },
        infraestruturasPrestadorasIds() {

            return this.data.model.prestadoresInternos.map(p => p.infraestruturaId)
        }
    },
    data: () => ({
        model: {
            id: null,
            ativo: true,
            unidadeId: null,
            infraestruturaId: null,
            exames: [],
            procedimentosCirurgicos: [],
            especialidades: [],
        }
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.infraestruturaJaAdicionada()) {

                        this.showValidationNotification('O local de atendimento já foi incluído.')

                        return
                    }

                    this.data.model.prestadoresInternos.push(this.prepareData())

                    this.$emit('save')
                })
        },
        infraestruturaJaAdicionada() {

            return !!this.data.model.prestadoresInternos.find(p => p.infraestruturaId === this.model.infraestruturaId)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.unidadeNomeFantasia = this.data.form.unidades.find(u => u.id === data.unidadeId).nomeFantasia
            data.infraestruturaNome = this.infraestruturas.find(u => u.id === data.infraestruturaId).nome

            return data
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'model.unidadeId'() {

            this.model.infraestruturaId = null
        },
        infraestruturas(infraestruturas) {

            if (infraestruturas.length === 1) {

                this.model.infraestruturaId = infraestruturas[0].id
            }
        }
    }
}
</script>